var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_setup.template)?_c(_setup.LoadingSpan,{attrs:{"message":"Loading storage location templates"}}):_c(_setup.CreateForm,{attrs:{"template":_setup.template},on:{"created":_setup.onCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }